import type { SiteName } from '@/scopes/common/domain/types'

const SELF_SERVICE_URLS: Partial<Record<SiteName, string>> = {
  elizabe: '/mijn-eliza/boeking/bewerken/serviceeditpage',
  elizanl: '/mijn-eliza/boeking/bewerken/serviceeditpage',
  sunwebbefr: '/fr/mon-sunweb/booking/modifier-vos-informations/serviceeditpage',
  sunwebbenl: '/nl/mijn-sunweb/boeking/bewerken/serviceeditpage',
  sunwebde: '/mein-sunweb/buchungsseite/bearbeiten/serviceeditpage',
  sunwebdk: '/mit-sunweb/booking/selvbetjening/serviceeditpage',
  sunwebfr: '/mon-sunweb/booking/modifier-vos-informations/serviceeditpage',
  sunwebnl: '/mijn-sunweb/boeking/bewerken/serviceeditpage',
  sunwebse: '/mitt-sunweb/booking/sjalvbetjaning/serviceeditpage',
  sunwebuk: '/my/booking/edit/serviceeditpage',
}

export function getSelfServiceUrl(siteName: SiteName): string | undefined {
  return SELF_SERVICE_URLS[siteName]
}

export function buildSelfServiceUrl(
  siteName: SiteName,
  bookingNumber: string,
  serviceType?: string,
): string | undefined {
  const baseUrl = getSelfServiceUrl(siteName)
  if (!baseUrl) {
    return undefined
  }

  const params = new URLSearchParams({ bookingNumber })

  // Temporary code for the self-service page returns to the new booking detail page.
  // When all sites are migrated to the new booking detail page and self-service always return to new booking detail page, this can be removed.
  params.set('source', 'new-booking-detail-page')

  if (serviceType) {
    params.set('serviceType', serviceType)
  }

  return `${baseUrl}?${params.toString()}`
}
